import { TemplateRef } from '@angular/core';
import { HeaderContentConfig } from '../../notes/header-content/header-content.constants';

export enum HeaderContentDirections {
  row = 'row',
  column = 'column',
}

export class ContentConfiguration {
  [prop: string]: TemplateRef<any>;
}

export class HeaderContentGridConfiguration {
  direction?: HeaderContentDirections = HeaderContentDirections.column;
  headerContent?: HeaderContentConfig[];

  constructor(options = {}) {
    Object.assign(this, options);
  }
}
